// import $ from 'jquery';
import _ from 'underscore';
import get from 'lodash.get';

class AdTagBuilder {
    constructor(url) {
        this.video_url = url;
        this.params = this.getParams();
        this.adUrl = this.buildAdURL();
    }

    buildAdURL() {
        var keyVals = this._determineCustomParam();
        var keyValString = '';
        _.each(keyVals, function (value, key) {
            keyValString += `%26${key}=${value}`;
        });
        var t = 'https://pubads.g.doubleclick.net/gampad/ads?' +
            'sz=640x360' +
            '&impl=s' +
            '&gdfp_req=1' +
            '&env=vp' +
            '&output=vast' +
            '&unviewed_position_start=1' +
            '&vad_type=linear' +
            '&vpos=preroll' +
            //'&url=%5Breferrer_url%5D' +
            '&correlator=' + Date.now() +
            //'&iu=' + this.params.zone + '/preroll' +
            '&iu=' + this.buildAdZone(this.params.zone) +
            //'&location=item-location__' +
            //'&camera=item-camera' +
            // Custom Params:
            // TESTING:
            //'&cust_params=cms%3Ddfp_video_test';
            // PRODUCTION:
            '&cust_params=video_tags%3D' + window.DFPtags +
            '%26vport=' + this.getEmbedViewport() +
            '%26video_id=__item-mediaid__' +
            keyValString;
        return t;
    }

    getParams() {
        var params = {};
        var query = this.video_url.search.substring(1);
        var vars = query.split('&');
        for (var i = 0; i < vars.length; i++) {
            var pair = vars[i].split('=');
            params[pair[0]] = decodeURIComponent(pair[1]);
        }
        return params;
    }

    buildAdZone(adZone) {
        if (adZone) {
            // Creates Array, ex: ["", "4160", "mv.fc", "studios", "aleapforward"]
            var adZoneArray = adZone.split('/');


            if (adZoneArray[3] === 'studios' ||
                adZoneArray[3] === 'advertorial') {
                adZoneArray.push('preroll_watch');
                // Returns string, ex "/4160/mv.fc/studios/aleapforward/preroll_watch"
                return adZoneArray.join('/');
            }

            adZoneArray[3] = 'studios';
            adZoneArray.push('preroll_embedded');
            // Returns string, ex "/4160/mv.fc/studios/aleapforward/preroll_embedded"
            return adZoneArray.join('/');
        }
        return '';
    }

    getEmbedViewport() {
        let w = window.innerWidth;

        // on large viewport, embed will always be 720px wide
        if (w === 720) {
            return 'l';
        }
        // in some cases, video expands beyond 720px for medium viewports (first case)
        // in other cases, it is smaller but not smaller than a 640px viewport - apx 2 columns (second case)
        if (w > 720 || (w < 720 && w > 600)) {
            return 'm';
        }

        // else, small:
        return 's';
    }

    _determineCustomParam() {
        let model = undefined;
        const params = {};
        try {
            model = get(window, 'parent.bootstrap_obj');
        } catch (merr) {
            /* eslint-disable no-console */
            console.error(merr);
        }

        if (!model) {
            return;
        }

        const type = model.type;
        const kind = model.kind;
        const topic = model.topic;
        const supertag = model.supertag;
        const tags = model.tags;
        const author = model.author;
        const keywords = model.keywords;

        if (kind === undefined) {
            params.c_type = type;
        } else {
            params.c_type = kind || '';
        }

        if (typeof Krux !== "undefined") {
            params.ksg = Krux.segments || [];
            params.kuid = Krux.user || '';
        }

        try {
            params.scroll = get(window, 'parent.bootstrap_obj.infiniteScrollPageNum') || 0;
        } catch (perr) {
            console.error(perr); /* eslint-disable no-console */
            params.scroll = 0;
        }

        params.chn = [];
        if (topic && topic.slug) {
            params.chn.push(topic.slug);
        }
        if (supertag && supertag.slug) {
            params.chn.push(supertag.slug);
        }

        //TAGS
        if (tags) {
            var tagslugs = [];
            $.each(tags, function (index, tag) {
                if (tag.slug) {
                    tagslugs.push(tag.slug);
                }
            });

            if (tagslugs.length) {
                params.tags = tagslugs;
            }
        }

        if (keywords && keywords.socialtags) {

            if (!params.tags) {
                params.tags = [];
            }

            $.each(keywords.socialtags, function (index, keyword) {
                params.tags.push(keyword);
            });

            params.tags = $.unique(params.tags);
        }

        if (params.tags) {
            params.tags = $.unique(params.tags);
        }

        params.slide = (kind === 'slideshow') ? 1 : 0;
        // if (util.get('fastcache')) {
        //     params.login = 'yes'; //(util.get('fastcache') ? 1 : 0);
        // }

        //VIDEO
        params.video = (kind === 'video' || kind === 'watch') ? 'yes' : 'no';

        // If kind is watch set global object _refreshOnVideoChange in order to enable listening to messages
        if (kind === "watch") {
            window._refreshOnVideoChange = true;
        }

        //AUTHOR
        params.aut = ((author && author.name) ? String(author.name).toLowerCase().replace(/\s+/g, '') : '');

        //Switched page level nsfw key/value to adzone
        // params.nsfw = this.ads.nsfw ? 'yes' : 'no';

        // Key val identifier for ad request coming into redesign
        params.abgroup = '1';

        return params;
    }

    // parses our playlistcount from a url
    // getPlaylistCount(url) {
    //     var matchedID = url.match(/&playlistCount=(.*)/);
    //     if (matchedID && matchedID[1]) {
    //         return matchedID[1];
    //     }
    //     return '';
    // }

    // Parses video ID from URL
    // getVideoID(url) {
    //     var matchedID = url.match(/embed\/(.*)\?/)[1];
    //     if (matchedID) {
    //         return matchedID;
    //     }
    //     return '';
    // }
}

export default new AdTagBuilder(window.location);
